// Models
/**
 * Represents a fixed date of a recurrence.
 * @example 31st of each month.
 * @example 14th of February.
 */ export class FixedDate {
    resolveDateForPeriod(arbitraryDateWithinPeriod) {
        const month = this.getMonthForPeriod(arbitraryDateWithinPeriod);
        // If the day of month exceeds the number of days in the month, clamp it to the last day of the month.
        return arbitraryDateWithinPeriod.with({
            day: this.dayOfMonth,
            month
        }, {
            overflow: "constrain"
        });
    }
    constructor(dayOfMonth){
        this.dayOfMonth = dayOfMonth;
    }
}
